import styled from 'styled-components';

export const StyledSVG = styled.svg`
    width: 17px;
    height: 10px;
    fill: none;
`;

export const Path = styled.path`
    fill: #33CC99;
`;

export const Button = styled.button`
    display: flex;
    background: transparent;
    padding: 5px;
    cursor: pointer;
    border: none;
    box-shadow: none;
    user-select: none;
    outline: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;